import React, { Component } from 'react';
import { Example, Properties } from 'examples';
import BaseRenderer from './BaseRenderer';
import Button from '../Button/Button';
import ContentRenderer from './ContentRenderer';
import Group from '../Group/Group';
import IconRenderer from './IconRenderer';

class RenderersExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      baseRenderer: {
        expanded: false,
        title: 'BaseRenderer',
      },
      iconRenderer: {
        expanded: false,
        iconName: 'list_smart',
        title: 'Smart List',
        tags: ['mobile', 'tablet', 'web'],
      },
      contentRenderer: {
        expanded: false,
        type: 'asset',
        imageUrl: 'https://images.unsplash.com/photo-1485872304698-0537e003288d?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=',
        title: 'The best movie of all time',
        description: '2017-12-01 08:35',
        tag: 'Draft',
        footer: 'asset',
        locked: true,
        linked: true,
        warning: 'Asset is not published',
      },
    };
  }

  onExpandCollapseBase = (e, expanded) => this.setState({ baseRenderer: { ...this.state.baseRenderer, expanded } });

  onExpandCollapseContent = (e, expanded) => this.setState({ contentRenderer: { ...this.state.contentRenderer, expanded } });

  onExpandCollapseIcon = (e, expanded) => this.setState({ iconRenderer: { ...this.state.iconRenderer, expanded } });

  onChangeBaseRenderer = e => this.setState({ baseRenderer: e.target.value });

  onChangeContentRenderer = e => this.setState({ contentRenderer: e.target.value });

  onChangeIconRenderer = e => this.setState({ iconRenderer: e.target.value });

  onCreateMenuItems = e => [
    <Button key="1">Menu item 1</Button>,
    <Button key="2">Menu item 2</Button>,
  ];

  getPropsSansExpanded = props => {
    const { expanded, ...rest } = props;

    return rest;
  };

  render() {
    const baseRenderer = this.getPropsSansExpanded(this.state.baseRenderer);
    const contentRenderer = this.getPropsSansExpanded(this.state.contentRenderer);
    const iconRenderer = this.getPropsSansExpanded(this.state.iconRenderer);

    return (
      <Example {...this.props}>
        <p>
          <strong>vimond-core-components</strong> comes with a number of renderers that can be used inside
          the <a href="/list"><code>List</code></a> component (and possibly <a href="/table"><code>Table</code></a> and&nbsp;
          <a href="/tree"><code>Tree</code></a> but this has not been tested yet).
        </p>
        <Group title="BaseRenderer">
          <Properties defaultProps={BaseRenderer.defaultProps} propTypes={BaseRenderer.propTypes} propValues={this.state.baseRenderer} onChange={this.onChangeBaseRenderer} expanded={this.state.baseRenderer.expanded} onClick={this.onExpandCollapseBase}/>
          <ul className="fake-list">
            <li>
              <BaseRenderer {...baseRenderer} onCreateMenuItems={this.onCreateMenuItems}/>
            </li>
            <li className="selected">
              <BaseRenderer {...baseRenderer} onCreateMenuItems={this.onCreateMenuItems}/>
            </li>
          </ul>
        </Group>
        <Group title="ContentRenderer">
          <Properties defaultProps={ContentRenderer.defaultProps} propTypes={ContentRenderer.propTypes} propValues={this.state.contentRenderer} onChange={this.onChangeContentRenderer} expanded={this.state.contentRenderer.expanded} onClick={this.onExpandCollapseContent}/>
          <ul className="fake-list">
            <li>
              <ContentRenderer {...contentRenderer} onCreateMenuItems={this.onCreateMenuItems}/>
            </li>
            <li className="selected">
              <ContentRenderer {...contentRenderer} onCreateMenuItems={this.onCreateMenuItems}/>
            </li>
          </ul>
        </Group>
        <Group title="IconRenderer">
          <Properties defaultProps={IconRenderer.defaultProps} propTypes={IconRenderer.propTypes} propValues={this.state.iconRenderer} onChange={this.onChangeIconRenderer} expanded={this.state.iconRenderer.expanded} onClick={this.onExpandCollapseIcon}/>
          <ul className="fake-list">
            <li>
              <IconRenderer {...iconRenderer} onCreateMenuItems={this.onCreateMenuItems}/>
            </li>
            <li className="selected">
              <IconRenderer {...iconRenderer} onCreateMenuItems={this.onCreateMenuItems}/>
            </li>
          </ul>
        </Group>
      </Example>
    );
  }

}

RenderersExample.tags = 'base icon content renderer';

export default RenderersExample;
